// test56
(56 && 0);
